/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as UiRouteImport } from './routes/ui';
import { Route as RequestDemoRouteImport } from './routes/request-demo';
import { Route as PricingRouteImport } from './routes/pricing';
import { Route as HardwarePricingRouteImport } from './routes/hardware-pricing';
import { Route as ContactRouteImport } from './routes/contact';
import { Route as ChangelogRouteImport } from './routes/changelog';
import { Route as AboutRouteImport } from './routes/about';
import { Route as LangRouteImport } from './routes/$lang';
import { Route as IndexRouteImport } from './routes/index';
import { Route as UseCasesIndexRouteImport } from './routes/use-cases/index';
import { Route as PlatformIndexRouteImport } from './routes/platform/index';
import { Route as CompareIndexRouteImport } from './routes/compare/index';
import { Route as LangIndexRouteImport } from './routes/$lang/index';
import { Route as UseCasesSlugRouteImport } from './routes/use-cases/$slug';
import { Route as PlatformProjectsRouteImport } from './routes/platform/projects';
import { Route as PlatformKnowledgeRouteImport } from './routes/platform/knowledge';
import { Route as PlatformGovernanceRouteImport } from './routes/platform/governance';
import { Route as PlatformChatRouteImport } from './routes/platform/chat';
import { Route as PlatformAutomationsRouteImport } from './routes/platform/automations';
import { Route as PlatformAgentsRouteImport } from './routes/platform/agents';
import { Route as LegalSlugRouteImport } from './routes/legal/$slug';
import { Route as CompareSlugRouteImport } from './routes/compare/$slug';
import { Route as LangUiRouteImport } from './routes/$lang/ui';
import { Route as LangRequestDemoRouteImport } from './routes/$lang/request-demo';
import { Route as LangPricingRouteImport } from './routes/$lang/pricing';
import { Route as LangHardwarePricingRouteImport } from './routes/$lang/hardware-pricing';
import { Route as LangContactRouteImport } from './routes/$lang/contact';
import { Route as LangChangelogRouteImport } from './routes/$lang/changelog';
import { Route as LangAboutRouteImport } from './routes/$lang/about';
import { Route as LangUseCasesIndexRouteImport } from './routes/$lang/use-cases/index';
import { Route as LangPlatformIndexRouteImport } from './routes/$lang/platform/index';
import { Route as LangCompareIndexRouteImport } from './routes/$lang/compare/index';
import { Route as LangUseCasesSlugRouteImport } from './routes/$lang/use-cases/$slug';
import { Route as LangPlatformProjectsRouteImport } from './routes/$lang/platform/projects';
import { Route as LangPlatformKnowledgeRouteImport } from './routes/$lang/platform/knowledge';
import { Route as LangPlatformGovernanceRouteImport } from './routes/$lang/platform/governance';
import { Route as LangPlatformChatRouteImport } from './routes/$lang/platform/chat';
import { Route as LangPlatformAutomationsRouteImport } from './routes/$lang/platform/automations';
import { Route as LangPlatformAgentsRouteImport } from './routes/$lang/platform/agents';
import { Route as LangLegalSlugRouteImport } from './routes/$lang/legal/$slug';
import { Route as LangCompareSlugRouteImport } from './routes/$lang/compare/$slug';

const UiRoute = UiRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => rootRouteImport,
} as any);
const RequestDemoRoute = RequestDemoRouteImport.update({
  id: '/request-demo',
  path: '/request-demo',
  getParentRoute: () => rootRouteImport,
} as any);
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any);
const HardwarePricingRoute = HardwarePricingRouteImport.update({
  id: '/hardware-pricing',
  path: '/hardware-pricing',
  getParentRoute: () => rootRouteImport,
} as any);
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any);
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any);
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any);
const LangRoute = LangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const UseCasesIndexRoute = UseCasesIndexRouteImport.update({
  id: '/use-cases/',
  path: '/use-cases/',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => rootRouteImport,
} as any);
const CompareIndexRoute = CompareIndexRouteImport.update({
  id: '/compare/',
  path: '/compare/',
  getParentRoute: () => rootRouteImport,
} as any);
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRoute,
} as any);
const UseCasesSlugRoute = UseCasesSlugRouteImport.update({
  id: '/use-cases/$slug',
  path: '/use-cases/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformProjectsRoute = PlatformProjectsRouteImport.update({
  id: '/platform/projects',
  path: '/platform/projects',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformKnowledgeRoute = PlatformKnowledgeRouteImport.update({
  id: '/platform/knowledge',
  path: '/platform/knowledge',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformGovernanceRoute = PlatformGovernanceRouteImport.update({
  id: '/platform/governance',
  path: '/platform/governance',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformChatRoute = PlatformChatRouteImport.update({
  id: '/platform/chat',
  path: '/platform/chat',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformAutomationsRoute = PlatformAutomationsRouteImport.update({
  id: '/platform/automations',
  path: '/platform/automations',
  getParentRoute: () => rootRouteImport,
} as any);
const PlatformAgentsRoute = PlatformAgentsRouteImport.update({
  id: '/platform/agents',
  path: '/platform/agents',
  getParentRoute: () => rootRouteImport,
} as any);
const LegalSlugRoute = LegalSlugRouteImport.update({
  id: '/legal/$slug',
  path: '/legal/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const CompareSlugRoute = CompareSlugRouteImport.update({
  id: '/compare/$slug',
  path: '/compare/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const LangUiRoute = LangUiRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => LangRoute,
} as any);
const LangRequestDemoRoute = LangRequestDemoRouteImport.update({
  id: '/request-demo',
  path: '/request-demo',
  getParentRoute: () => LangRoute,
} as any);
const LangPricingRoute = LangPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => LangRoute,
} as any);
const LangHardwarePricingRoute = LangHardwarePricingRouteImport.update({
  id: '/hardware-pricing',
  path: '/hardware-pricing',
  getParentRoute: () => LangRoute,
} as any);
const LangContactRoute = LangContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LangRoute,
} as any);
const LangChangelogRoute = LangChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => LangRoute,
} as any);
const LangAboutRoute = LangAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LangRoute,
} as any);
const LangUseCasesIndexRoute = LangUseCasesIndexRouteImport.update({
  id: '/use-cases/',
  path: '/use-cases/',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformIndexRoute = LangPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => LangRoute,
} as any);
const LangCompareIndexRoute = LangCompareIndexRouteImport.update({
  id: '/compare/',
  path: '/compare/',
  getParentRoute: () => LangRoute,
} as any);
const LangUseCasesSlugRoute = LangUseCasesSlugRouteImport.update({
  id: '/use-cases/$slug',
  path: '/use-cases/$slug',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformProjectsRoute = LangPlatformProjectsRouteImport.update({
  id: '/platform/projects',
  path: '/platform/projects',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformKnowledgeRoute = LangPlatformKnowledgeRouteImport.update({
  id: '/platform/knowledge',
  path: '/platform/knowledge',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformGovernanceRoute = LangPlatformGovernanceRouteImport.update({
  id: '/platform/governance',
  path: '/platform/governance',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformChatRoute = LangPlatformChatRouteImport.update({
  id: '/platform/chat',
  path: '/platform/chat',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformAutomationsRoute = LangPlatformAutomationsRouteImport.update({
  id: '/platform/automations',
  path: '/platform/automations',
  getParentRoute: () => LangRoute,
} as any);
const LangPlatformAgentsRoute = LangPlatformAgentsRouteImport.update({
  id: '/platform/agents',
  path: '/platform/agents',
  getParentRoute: () => LangRoute,
} as any);
const LangLegalSlugRoute = LangLegalSlugRouteImport.update({
  id: '/legal/$slug',
  path: '/legal/$slug',
  getParentRoute: () => LangRoute,
} as any);
const LangCompareSlugRoute = LangCompareSlugRouteImport.update({
  id: '/compare/$slug',
  path: '/compare/$slug',
  getParentRoute: () => LangRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/$lang': typeof LangRouteWithChildren;
  '/about': typeof AboutRoute;
  '/changelog': typeof ChangelogRoute;
  '/contact': typeof ContactRoute;
  '/hardware-pricing': typeof HardwarePricingRoute;
  '/pricing': typeof PricingRoute;
  '/request-demo': typeof RequestDemoRoute;
  '/ui': typeof UiRoute;
  '/$lang/about': typeof LangAboutRoute;
  '/$lang/changelog': typeof LangChangelogRoute;
  '/$lang/contact': typeof LangContactRoute;
  '/$lang/hardware-pricing': typeof LangHardwarePricingRoute;
  '/$lang/pricing': typeof LangPricingRoute;
  '/$lang/request-demo': typeof LangRequestDemoRoute;
  '/$lang/ui': typeof LangUiRoute;
  '/compare/$slug': typeof CompareSlugRoute;
  '/legal/$slug': typeof LegalSlugRoute;
  '/platform/agents': typeof PlatformAgentsRoute;
  '/platform/automations': typeof PlatformAutomationsRoute;
  '/platform/chat': typeof PlatformChatRoute;
  '/platform/governance': typeof PlatformGovernanceRoute;
  '/platform/knowledge': typeof PlatformKnowledgeRoute;
  '/platform/projects': typeof PlatformProjectsRoute;
  '/use-cases/$slug': typeof UseCasesSlugRoute;
  '/$lang/': typeof LangIndexRoute;
  '/compare/': typeof CompareIndexRoute;
  '/platform/': typeof PlatformIndexRoute;
  '/use-cases/': typeof UseCasesIndexRoute;
  '/$lang/compare/$slug': typeof LangCompareSlugRoute;
  '/$lang/legal/$slug': typeof LangLegalSlugRoute;
  '/$lang/platform/agents': typeof LangPlatformAgentsRoute;
  '/$lang/platform/automations': typeof LangPlatformAutomationsRoute;
  '/$lang/platform/chat': typeof LangPlatformChatRoute;
  '/$lang/platform/governance': typeof LangPlatformGovernanceRoute;
  '/$lang/platform/knowledge': typeof LangPlatformKnowledgeRoute;
  '/$lang/platform/projects': typeof LangPlatformProjectsRoute;
  '/$lang/use-cases/$slug': typeof LangUseCasesSlugRoute;
  '/$lang/compare/': typeof LangCompareIndexRoute;
  '/$lang/platform/': typeof LangPlatformIndexRoute;
  '/$lang/use-cases/': typeof LangUseCasesIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/about': typeof AboutRoute;
  '/changelog': typeof ChangelogRoute;
  '/contact': typeof ContactRoute;
  '/hardware-pricing': typeof HardwarePricingRoute;
  '/pricing': typeof PricingRoute;
  '/request-demo': typeof RequestDemoRoute;
  '/ui': typeof UiRoute;
  '/$lang/about': typeof LangAboutRoute;
  '/$lang/changelog': typeof LangChangelogRoute;
  '/$lang/contact': typeof LangContactRoute;
  '/$lang/hardware-pricing': typeof LangHardwarePricingRoute;
  '/$lang/pricing': typeof LangPricingRoute;
  '/$lang/request-demo': typeof LangRequestDemoRoute;
  '/$lang/ui': typeof LangUiRoute;
  '/compare/$slug': typeof CompareSlugRoute;
  '/legal/$slug': typeof LegalSlugRoute;
  '/platform/agents': typeof PlatformAgentsRoute;
  '/platform/automations': typeof PlatformAutomationsRoute;
  '/platform/chat': typeof PlatformChatRoute;
  '/platform/governance': typeof PlatformGovernanceRoute;
  '/platform/knowledge': typeof PlatformKnowledgeRoute;
  '/platform/projects': typeof PlatformProjectsRoute;
  '/use-cases/$slug': typeof UseCasesSlugRoute;
  '/$lang': typeof LangIndexRoute;
  '/compare': typeof CompareIndexRoute;
  '/platform': typeof PlatformIndexRoute;
  '/use-cases': typeof UseCasesIndexRoute;
  '/$lang/compare/$slug': typeof LangCompareSlugRoute;
  '/$lang/legal/$slug': typeof LangLegalSlugRoute;
  '/$lang/platform/agents': typeof LangPlatformAgentsRoute;
  '/$lang/platform/automations': typeof LangPlatformAutomationsRoute;
  '/$lang/platform/chat': typeof LangPlatformChatRoute;
  '/$lang/platform/governance': typeof LangPlatformGovernanceRoute;
  '/$lang/platform/knowledge': typeof LangPlatformKnowledgeRoute;
  '/$lang/platform/projects': typeof LangPlatformProjectsRoute;
  '/$lang/use-cases/$slug': typeof LangUseCasesSlugRoute;
  '/$lang/compare': typeof LangCompareIndexRoute;
  '/$lang/platform': typeof LangPlatformIndexRoute;
  '/$lang/use-cases': typeof LangUseCasesIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/$lang': typeof LangRouteWithChildren;
  '/about': typeof AboutRoute;
  '/changelog': typeof ChangelogRoute;
  '/contact': typeof ContactRoute;
  '/hardware-pricing': typeof HardwarePricingRoute;
  '/pricing': typeof PricingRoute;
  '/request-demo': typeof RequestDemoRoute;
  '/ui': typeof UiRoute;
  '/$lang/about': typeof LangAboutRoute;
  '/$lang/changelog': typeof LangChangelogRoute;
  '/$lang/contact': typeof LangContactRoute;
  '/$lang/hardware-pricing': typeof LangHardwarePricingRoute;
  '/$lang/pricing': typeof LangPricingRoute;
  '/$lang/request-demo': typeof LangRequestDemoRoute;
  '/$lang/ui': typeof LangUiRoute;
  '/compare/$slug': typeof CompareSlugRoute;
  '/legal/$slug': typeof LegalSlugRoute;
  '/platform/agents': typeof PlatformAgentsRoute;
  '/platform/automations': typeof PlatformAutomationsRoute;
  '/platform/chat': typeof PlatformChatRoute;
  '/platform/governance': typeof PlatformGovernanceRoute;
  '/platform/knowledge': typeof PlatformKnowledgeRoute;
  '/platform/projects': typeof PlatformProjectsRoute;
  '/use-cases/$slug': typeof UseCasesSlugRoute;
  '/$lang/': typeof LangIndexRoute;
  '/compare/': typeof CompareIndexRoute;
  '/platform/': typeof PlatformIndexRoute;
  '/use-cases/': typeof UseCasesIndexRoute;
  '/$lang/compare/$slug': typeof LangCompareSlugRoute;
  '/$lang/legal/$slug': typeof LangLegalSlugRoute;
  '/$lang/platform/agents': typeof LangPlatformAgentsRoute;
  '/$lang/platform/automations': typeof LangPlatformAutomationsRoute;
  '/$lang/platform/chat': typeof LangPlatformChatRoute;
  '/$lang/platform/governance': typeof LangPlatformGovernanceRoute;
  '/$lang/platform/knowledge': typeof LangPlatformKnowledgeRoute;
  '/$lang/platform/projects': typeof LangPlatformProjectsRoute;
  '/$lang/use-cases/$slug': typeof LangUseCasesSlugRoute;
  '/$lang/compare/': typeof LangCompareIndexRoute;
  '/$lang/platform/': typeof LangPlatformIndexRoute;
  '/$lang/use-cases/': typeof LangUseCasesIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/$lang'
    | '/about'
    | '/changelog'
    | '/contact'
    | '/hardware-pricing'
    | '/pricing'
    | '/request-demo'
    | '/ui'
    | '/$lang/about'
    | '/$lang/changelog'
    | '/$lang/contact'
    | '/$lang/hardware-pricing'
    | '/$lang/pricing'
    | '/$lang/request-demo'
    | '/$lang/ui'
    | '/compare/$slug'
    | '/legal/$slug'
    | '/platform/agents'
    | '/platform/automations'
    | '/platform/chat'
    | '/platform/governance'
    | '/platform/knowledge'
    | '/platform/projects'
    | '/use-cases/$slug'
    | '/$lang/'
    | '/compare/'
    | '/platform/'
    | '/use-cases/'
    | '/$lang/compare/$slug'
    | '/$lang/legal/$slug'
    | '/$lang/platform/agents'
    | '/$lang/platform/automations'
    | '/$lang/platform/chat'
    | '/$lang/platform/governance'
    | '/$lang/platform/knowledge'
    | '/$lang/platform/projects'
    | '/$lang/use-cases/$slug'
    | '/$lang/compare/'
    | '/$lang/platform/'
    | '/$lang/use-cases/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/about'
    | '/changelog'
    | '/contact'
    | '/hardware-pricing'
    | '/pricing'
    | '/request-demo'
    | '/ui'
    | '/$lang/about'
    | '/$lang/changelog'
    | '/$lang/contact'
    | '/$lang/hardware-pricing'
    | '/$lang/pricing'
    | '/$lang/request-demo'
    | '/$lang/ui'
    | '/compare/$slug'
    | '/legal/$slug'
    | '/platform/agents'
    | '/platform/automations'
    | '/platform/chat'
    | '/platform/governance'
    | '/platform/knowledge'
    | '/platform/projects'
    | '/use-cases/$slug'
    | '/$lang'
    | '/compare'
    | '/platform'
    | '/use-cases'
    | '/$lang/compare/$slug'
    | '/$lang/legal/$slug'
    | '/$lang/platform/agents'
    | '/$lang/platform/automations'
    | '/$lang/platform/chat'
    | '/$lang/platform/governance'
    | '/$lang/platform/knowledge'
    | '/$lang/platform/projects'
    | '/$lang/use-cases/$slug'
    | '/$lang/compare'
    | '/$lang/platform'
    | '/$lang/use-cases';
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/about'
    | '/changelog'
    | '/contact'
    | '/hardware-pricing'
    | '/pricing'
    | '/request-demo'
    | '/ui'
    | '/$lang/about'
    | '/$lang/changelog'
    | '/$lang/contact'
    | '/$lang/hardware-pricing'
    | '/$lang/pricing'
    | '/$lang/request-demo'
    | '/$lang/ui'
    | '/compare/$slug'
    | '/legal/$slug'
    | '/platform/agents'
    | '/platform/automations'
    | '/platform/chat'
    | '/platform/governance'
    | '/platform/knowledge'
    | '/platform/projects'
    | '/use-cases/$slug'
    | '/$lang/'
    | '/compare/'
    | '/platform/'
    | '/use-cases/'
    | '/$lang/compare/$slug'
    | '/$lang/legal/$slug'
    | '/$lang/platform/agents'
    | '/$lang/platform/automations'
    | '/$lang/platform/chat'
    | '/$lang/platform/governance'
    | '/$lang/platform/knowledge'
    | '/$lang/platform/projects'
    | '/$lang/use-cases/$slug'
    | '/$lang/compare/'
    | '/$lang/platform/'
    | '/$lang/use-cases/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LangRoute: typeof LangRouteWithChildren;
  AboutRoute: typeof AboutRoute;
  ChangelogRoute: typeof ChangelogRoute;
  ContactRoute: typeof ContactRoute;
  HardwarePricingRoute: typeof HardwarePricingRoute;
  PricingRoute: typeof PricingRoute;
  RequestDemoRoute: typeof RequestDemoRoute;
  UiRoute: typeof UiRoute;
  CompareSlugRoute: typeof CompareSlugRoute;
  LegalSlugRoute: typeof LegalSlugRoute;
  PlatformAgentsRoute: typeof PlatformAgentsRoute;
  PlatformAutomationsRoute: typeof PlatformAutomationsRoute;
  PlatformChatRoute: typeof PlatformChatRoute;
  PlatformGovernanceRoute: typeof PlatformGovernanceRoute;
  PlatformKnowledgeRoute: typeof PlatformKnowledgeRoute;
  PlatformProjectsRoute: typeof PlatformProjectsRoute;
  UseCasesSlugRoute: typeof UseCasesSlugRoute;
  CompareIndexRoute: typeof CompareIndexRoute;
  PlatformIndexRoute: typeof PlatformIndexRoute;
  UseCasesIndexRoute: typeof UseCasesIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ui': {
      id: '/ui';
      path: '/ui';
      fullPath: '/ui';
      preLoaderRoute: typeof UiRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/request-demo': {
      id: '/request-demo';
      path: '/request-demo';
      fullPath: '/request-demo';
      preLoaderRoute: typeof RequestDemoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pricing': {
      id: '/pricing';
      path: '/pricing';
      fullPath: '/pricing';
      preLoaderRoute: typeof PricingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/hardware-pricing': {
      id: '/hardware-pricing';
      path: '/hardware-pricing';
      fullPath: '/hardware-pricing';
      preLoaderRoute: typeof HardwarePricingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contact': {
      id: '/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof ContactRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/changelog': {
      id: '/changelog';
      path: '/changelog';
      fullPath: '/changelog';
      preLoaderRoute: typeof ChangelogRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/about': {
      id: '/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof AboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$lang': {
      id: '/$lang';
      path: '/$lang';
      fullPath: '/$lang';
      preLoaderRoute: typeof LangRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/use-cases/': {
      id: '/use-cases/';
      path: '/use-cases';
      fullPath: '/use-cases/';
      preLoaderRoute: typeof UseCasesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/': {
      id: '/platform/';
      path: '/platform';
      fullPath: '/platform/';
      preLoaderRoute: typeof PlatformIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/compare/': {
      id: '/compare/';
      path: '/compare';
      fullPath: '/compare/';
      preLoaderRoute: typeof CompareIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$lang/': {
      id: '/$lang/';
      path: '/';
      fullPath: '/$lang/';
      preLoaderRoute: typeof LangIndexRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/use-cases/$slug': {
      id: '/use-cases/$slug';
      path: '/use-cases/$slug';
      fullPath: '/use-cases/$slug';
      preLoaderRoute: typeof UseCasesSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/projects': {
      id: '/platform/projects';
      path: '/platform/projects';
      fullPath: '/platform/projects';
      preLoaderRoute: typeof PlatformProjectsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/knowledge': {
      id: '/platform/knowledge';
      path: '/platform/knowledge';
      fullPath: '/platform/knowledge';
      preLoaderRoute: typeof PlatformKnowledgeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/governance': {
      id: '/platform/governance';
      path: '/platform/governance';
      fullPath: '/platform/governance';
      preLoaderRoute: typeof PlatformGovernanceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/chat': {
      id: '/platform/chat';
      path: '/platform/chat';
      fullPath: '/platform/chat';
      preLoaderRoute: typeof PlatformChatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/automations': {
      id: '/platform/automations';
      path: '/platform/automations';
      fullPath: '/platform/automations';
      preLoaderRoute: typeof PlatformAutomationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/platform/agents': {
      id: '/platform/agents';
      path: '/platform/agents';
      fullPath: '/platform/agents';
      preLoaderRoute: typeof PlatformAgentsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/legal/$slug': {
      id: '/legal/$slug';
      path: '/legal/$slug';
      fullPath: '/legal/$slug';
      preLoaderRoute: typeof LegalSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/compare/$slug': {
      id: '/compare/$slug';
      path: '/compare/$slug';
      fullPath: '/compare/$slug';
      preLoaderRoute: typeof CompareSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/$lang/ui': {
      id: '/$lang/ui';
      path: '/ui';
      fullPath: '/$lang/ui';
      preLoaderRoute: typeof LangUiRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/request-demo': {
      id: '/$lang/request-demo';
      path: '/request-demo';
      fullPath: '/$lang/request-demo';
      preLoaderRoute: typeof LangRequestDemoRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/pricing': {
      id: '/$lang/pricing';
      path: '/pricing';
      fullPath: '/$lang/pricing';
      preLoaderRoute: typeof LangPricingRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/hardware-pricing': {
      id: '/$lang/hardware-pricing';
      path: '/hardware-pricing';
      fullPath: '/$lang/hardware-pricing';
      preLoaderRoute: typeof LangHardwarePricingRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/contact': {
      id: '/$lang/contact';
      path: '/contact';
      fullPath: '/$lang/contact';
      preLoaderRoute: typeof LangContactRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/changelog': {
      id: '/$lang/changelog';
      path: '/changelog';
      fullPath: '/$lang/changelog';
      preLoaderRoute: typeof LangChangelogRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/about': {
      id: '/$lang/about';
      path: '/about';
      fullPath: '/$lang/about';
      preLoaderRoute: typeof LangAboutRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/use-cases/': {
      id: '/$lang/use-cases/';
      path: '/use-cases';
      fullPath: '/$lang/use-cases/';
      preLoaderRoute: typeof LangUseCasesIndexRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/': {
      id: '/$lang/platform/';
      path: '/platform';
      fullPath: '/$lang/platform/';
      preLoaderRoute: typeof LangPlatformIndexRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/compare/': {
      id: '/$lang/compare/';
      path: '/compare';
      fullPath: '/$lang/compare/';
      preLoaderRoute: typeof LangCompareIndexRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/use-cases/$slug': {
      id: '/$lang/use-cases/$slug';
      path: '/use-cases/$slug';
      fullPath: '/$lang/use-cases/$slug';
      preLoaderRoute: typeof LangUseCasesSlugRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/projects': {
      id: '/$lang/platform/projects';
      path: '/platform/projects';
      fullPath: '/$lang/platform/projects';
      preLoaderRoute: typeof LangPlatformProjectsRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/knowledge': {
      id: '/$lang/platform/knowledge';
      path: '/platform/knowledge';
      fullPath: '/$lang/platform/knowledge';
      preLoaderRoute: typeof LangPlatformKnowledgeRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/governance': {
      id: '/$lang/platform/governance';
      path: '/platform/governance';
      fullPath: '/$lang/platform/governance';
      preLoaderRoute: typeof LangPlatformGovernanceRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/chat': {
      id: '/$lang/platform/chat';
      path: '/platform/chat';
      fullPath: '/$lang/platform/chat';
      preLoaderRoute: typeof LangPlatformChatRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/automations': {
      id: '/$lang/platform/automations';
      path: '/platform/automations';
      fullPath: '/$lang/platform/automations';
      preLoaderRoute: typeof LangPlatformAutomationsRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/platform/agents': {
      id: '/$lang/platform/agents';
      path: '/platform/agents';
      fullPath: '/$lang/platform/agents';
      preLoaderRoute: typeof LangPlatformAgentsRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/legal/$slug': {
      id: '/$lang/legal/$slug';
      path: '/legal/$slug';
      fullPath: '/$lang/legal/$slug';
      preLoaderRoute: typeof LangLegalSlugRouteImport;
      parentRoute: typeof LangRoute;
    };
    '/$lang/compare/$slug': {
      id: '/$lang/compare/$slug';
      path: '/compare/$slug';
      fullPath: '/$lang/compare/$slug';
      preLoaderRoute: typeof LangCompareSlugRouteImport;
      parentRoute: typeof LangRoute;
    };
  }
}

interface LangRouteChildren {
  LangAboutRoute: typeof LangAboutRoute;
  LangChangelogRoute: typeof LangChangelogRoute;
  LangContactRoute: typeof LangContactRoute;
  LangHardwarePricingRoute: typeof LangHardwarePricingRoute;
  LangPricingRoute: typeof LangPricingRoute;
  LangRequestDemoRoute: typeof LangRequestDemoRoute;
  LangUiRoute: typeof LangUiRoute;
  LangIndexRoute: typeof LangIndexRoute;
  LangCompareSlugRoute: typeof LangCompareSlugRoute;
  LangLegalSlugRoute: typeof LangLegalSlugRoute;
  LangPlatformAgentsRoute: typeof LangPlatformAgentsRoute;
  LangPlatformAutomationsRoute: typeof LangPlatformAutomationsRoute;
  LangPlatformChatRoute: typeof LangPlatformChatRoute;
  LangPlatformGovernanceRoute: typeof LangPlatformGovernanceRoute;
  LangPlatformKnowledgeRoute: typeof LangPlatformKnowledgeRoute;
  LangPlatformProjectsRoute: typeof LangPlatformProjectsRoute;
  LangUseCasesSlugRoute: typeof LangUseCasesSlugRoute;
  LangCompareIndexRoute: typeof LangCompareIndexRoute;
  LangPlatformIndexRoute: typeof LangPlatformIndexRoute;
  LangUseCasesIndexRoute: typeof LangUseCasesIndexRoute;
}

const LangRouteChildren: LangRouteChildren = {
  LangAboutRoute: LangAboutRoute,
  LangChangelogRoute: LangChangelogRoute,
  LangContactRoute: LangContactRoute,
  LangHardwarePricingRoute: LangHardwarePricingRoute,
  LangPricingRoute: LangPricingRoute,
  LangRequestDemoRoute: LangRequestDemoRoute,
  LangUiRoute: LangUiRoute,
  LangIndexRoute: LangIndexRoute,
  LangCompareSlugRoute: LangCompareSlugRoute,
  LangLegalSlugRoute: LangLegalSlugRoute,
  LangPlatformAgentsRoute: LangPlatformAgentsRoute,
  LangPlatformAutomationsRoute: LangPlatformAutomationsRoute,
  LangPlatformChatRoute: LangPlatformChatRoute,
  LangPlatformGovernanceRoute: LangPlatformGovernanceRoute,
  LangPlatformKnowledgeRoute: LangPlatformKnowledgeRoute,
  LangPlatformProjectsRoute: LangPlatformProjectsRoute,
  LangUseCasesSlugRoute: LangUseCasesSlugRoute,
  LangCompareIndexRoute: LangCompareIndexRoute,
  LangPlatformIndexRoute: LangPlatformIndexRoute,
  LangUseCasesIndexRoute: LangUseCasesIndexRoute,
};

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRoute: LangRouteWithChildren,
  AboutRoute: AboutRoute,
  ChangelogRoute: ChangelogRoute,
  ContactRoute: ContactRoute,
  HardwarePricingRoute: HardwarePricingRoute,
  PricingRoute: PricingRoute,
  RequestDemoRoute: RequestDemoRoute,
  UiRoute: UiRoute,
  CompareSlugRoute: CompareSlugRoute,
  LegalSlugRoute: LegalSlugRoute,
  PlatformAgentsRoute: PlatformAgentsRoute,
  PlatformAutomationsRoute: PlatformAutomationsRoute,
  PlatformChatRoute: PlatformChatRoute,
  PlatformGovernanceRoute: PlatformGovernanceRoute,
  PlatformKnowledgeRoute: PlatformKnowledgeRoute,
  PlatformProjectsRoute: PlatformProjectsRoute,
  UseCasesSlugRoute: UseCasesSlugRoute,
  CompareIndexRoute: CompareIndexRoute,
  PlatformIndexRoute: PlatformIndexRoute,
  UseCasesIndexRoute: UseCasesIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
